import { z } from 'zod';
import { carrierName, suretyBondNumberCounterId } from '../../../types/opaque.mjs';

const rangeSchema = z.object({
    start: z.number().int().positive({ message: "Start must be a positive number" }),
    end: z.number().int().positive({ message: "End must be a positive number" }),
});
const counterResponseSchema = z.object({
    counterId: suretyBondNumberCounterId,
    carrierName: carrierName,
    carrierDisplayName: z.string(),
    prefix: z.string().nullable(),
    suffix: z.string().nullable(),
    current: z
        .object({
        value: z.number().int().positive(),
        end: z.number().int().positive(),
    })
        .nullable(),
    next: rangeSchema.nullable(),
});
var GetAll;
(function (GetAll) {
    GetAll.responseSchema = z.array(counterResponseSchema);
})(GetAll || (GetAll = {}));
var SetNextBlock;
(function (SetNextBlock) {
    (function (Request) {
        Request.schema = rangeSchema.refine((data) => data.end > data.start, {
            message: "End must be greater than start",
            path: ["end"],
        });
    })(SetNextBlock.Request || (SetNextBlock.Request = {}));
})(SetNextBlock || (SetNextBlock = {}));

export { GetAll, SetNextBlock };
